import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-media-highlights-slider .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.swiper-slide');

		if (slides.length < 2) {
			return;
		}

		const settings = {
			loop: false,
			grabCursor: true,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			breakpoints: {
				992: {
					spaceBetween: 72, // This should be calculated based on viewport width
				},
			},
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
		};

		new Swiper(slider, settings);
	});
}
